import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import OccupiedTable from "../../components/occupiedLocations"

const OccupiedLocations = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Occupied Locations | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <OccupiedTable />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default OccupiedLocations
